<div class="form-group mb-10">
    <label class="col-xs-9 control-label">
        {{ "background_settings_video" | translate }}
    </label>
    <div class="col-xs-3 text-right" [tooltip]="disabled() ? disabledTooltip : ''">
        <sp-switch [disabled]="disabled()" [active]="showSettings()" (toggleActiveEvent)="toggleShowSettings($event)" />
    </div>
</div>

<ng-template #disabledTooltip>
    {{ "background_video_tooltip" | translate }}
</ng-template>

@if (showSettings()) {
    <div class="form-group">
        <sp-file-manager
            [fmSourceType]="fmSourceType.LANDING"
            [file]="video()"
            [displayOnly]="[directoryItemCategory.Video]"
            (setFileEvent)="setVideo($event)"
            (replaceFileEvent)="replaceVideo($event)"
        >
            <ng-template #previewTemplate let-file="file" let-replaceFileFn="replaceFileFn">
                <div>
                    <sp-control-handle
                        [controlHandleMainText]="file.name"
                        (removeActionEvent)="toggleShowSettings(false)"
                        (replaceActionEvent)="replaceFileFn()"
                    />
                </div>
            </ng-template>
        </sp-file-manager>
        <div class="help-block mb-0 small text-muted">
            {{ "background_video_size_noty" | translate }}
        </div>
    </div>
}
